<script setup lang="ts">
import AddonCard from '../addons/components/AddonCard.vue'
import AddonDetail from '../addons/components/AddonDetail.vue'

import router from '../../router'

import type { AddonConfirmationModal } from '@/types/types'

const { availableAddons, confirmationModals, sendEvent, addonsList } = useAddon()
const { t } = useI18n()
const route = useRoute()

const title = t('sidebar.addons')

const isDetailOpen = computed(() => route.query?.slug?.length > 0)
const confirmationModal = ref<AddonConfirmationModal>(null)
const addonDetail = ref(null)

const openDetail = (addonId: number) => {
  addonDetail.value = addonsList.value.find((addon) => addon.id === addonId)
  router.push({ query: { slug: addonDetail.value.slug } })
  sendEvent(addonId, 'addons:clicked')
}

const openConfirmationModal = (confirmationModalId: number, buttonSlug: string) => {
  router.push({ query: {} })
  sendEvent(addonDetail.value.id, 'addons:detail:clicked', buttonSlug)
  confirmationModal.value = confirmationModals.find((confirmationModal) => confirmationModal.id === confirmationModalId)
}

const closeDetail = () => {
  router.push({ query: {} })
  addonDetail.value = null
}

const closeConfirmationModal = () => {
  closeDetail()
  confirmationModal.value = null
}

const openModalFromQuery = () => {
  const slug = route.query.slug
  if (!slug) {
    return
  }
  addonDetail.value = addonsList.value.find((addon) => addon.slug === slug)
}
openModalFromQuery()
</script>
<template>
  <TheListHeader :title="title" />
  <div class="px-6 pb-6 text-foreground sm:px-12 sm:pb-12">
    <div class="grid grid-cols-8 gap-8">
      <AddonCard :addons="availableAddons" :has-animation="true" @on-click="openDetail" />
    </div>
  </div>
  <BaseModal :heading-title="addonDetail?.content?.title" :is-open="isDetailOpen" @close="closeDetail">
    <AddonDetail v-if="addonDetail" :addon-detail="addonDetail" @on-click="openConfirmationModal" />
  </BaseModal>

  <BaseModal
    :is-open="!!confirmationModal"
    :text-title="confirmationModal?.title"
    :text="confirmationModal?.description"
    :link-text="confirmationModal?.buttonText"
    icon-color="green"
    icon="HeroCheckIconSolid"
    @click="closeConfirmationModal"
    @close="closeConfirmationModal"
  />
</template>
